exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.account-name[data-v-4d337116]{color:#fad962;font-size:18px\n}\n.breadcrumb-item[data-v-4d337116]{color:#fff;font-size:15px\n}\n.breadcrumb-divider[data-v-4d337116]{opacity:.5;padding:0 5px\n}\n.impersonate[data-v-4d337116]{display:block;font-size:11px\n}\n.btnStop[data-v-4d337116]{background-color:rgba(0,0,0,0);border:none;color:#ccc;font-size:11px;transition:all .4s\n}\n.btnStop[data-v-4d337116]:hover{transform:scale(1.05);cursor:pointer;color:#fa1f1f\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4d337116","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/Breadcrumbs.vue
// module id = 111
// module chunks = 0